import DownloadWidget from "./DownloadWidget";

export default DownloadWidget;
